import md5 from 'md5';

/**
 * Checks passwords against the hashed password and salt. See BGMP_Post_Passworder.php for an
 * explanation of the hashing.
 */
class PasswordChecker {

  /**
   * Constructor.
   *
   * @param {string} hashedPassword The hashed password.
   * @param {string} salt           The salt.
   */
  constructor({ hashedPassword, salt }) {
    if (!hashedPassword || !salt) {
      throw new Error('Missing password data for PasswordChecker');
    }
    this.hashedPassword = hashedPassword;
    this.salt = salt;
  }

  /**
   * Compute the hash of a given password with the salt.
   *
   * @param {string} input The password to check.
   * @returns {string} The hashed password.
   */
  computeHash(input) {
    const { salt } = this;
    return md5(input + salt);
  }

  /**
   * Check the password against the hashed password.
   *
   * @param {string} input The password to check.
   * @returns {boolean} Whether the password matches.
   */
  checkPassword(input) {
    const { hashedPassword } = this;
    return (this.computeHash(input) === hashedPassword);
  }
}

export default PasswordChecker;
